import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import "./MaintenanceScreen.css";

// Hook: escucha el documento config/site y devuelve { loading, on, message }.
// Usado por App para decidir si mostrar la pantalla de mantenimiento.
export const useMaintenance = () => {
  const [state, setState] = useState({ loading: true, on: false, message: "" });
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "config", "site"),
      (snap) => {
        const data = snap.exists() ? snap.data() : {};
        setState({
          loading: false,
          on: data.maintenanceMode === true,
          message: data.maintenanceMessage || "",
        });
      },
      () => setState({ loading: false, on: false, message: "" })
    );
    return () => unsub();
  }, []);
  return state;
};

const MaintenanceScreen = ({ message }) => (
  <div className="maintenance-screen">
    <div className="maintenance-card">
      <div className="maintenance-icon">🛠️</div>
      <h1>Estamos en mantenimiento</h1>
      <p>
        {message ||
          "Volvemos en breve. Estamos haciendo mejoras para vos. ¡Gracias por la paciencia!"}
      </p>
      {/* TODO: numero de WhatsApp perdido. Restaurar con la linea nueva.
      <a className="maintenance-wa" href="https://wa.me/NUEVO_NUMERO">
        Consultar por WhatsApp
      </a> */}
      <p className="maintenance-foot">Techteno</p>
    </div>
  </div>
);

export default MaintenanceScreen;
